import $ from 'jquery';
import { onClickAll, unsubscribeOnClickAll, onLongTouchAll, unsubscribeOnLongTouchAll } from './htmlListeners.js';
import * as selectItem from './itemSelectCounter.js';
import icon360 from '../img/icons/360.svg';
import iconVideo from '../img/icons/video.svg';
import iconImage from '../img/icons/image.svg';
import iconCheckboxChecked from '../img/icons/checkbox-checked.svg'
import iconCheckboxUnchecked from '../img/icons/checkbox-unchecked.svg';
import iconDownload from '../img/icons/icon-download.svg';
import iconShare from '../img/icons/icon-share-white.svg';
import { t } from './localization.js';
import { isMobile, isIPhone } from './utils-module.js';
import * as emptyText from './emptyUserImageText.js';

const itemCssPath = '.gallery__item';
const getItemCssPathWithId = (id) => `${itemCssPath}[data-id="${id}"]`;
const galleryCssPath = '.gallery';
const smallActionPanelContainerInGallery = '.gallery__item-small-action-panel';
const sharePlaceInGallery = '.gallery__item-btn-share';
const classHiddenSmallActionPanelContainerInGallery = 'gallery__item-small-action-panel_hidden';
const classHiddenCheckboxPlaceInGallery = 'gallery__item-checkbox_hidden';
const classHiddenSharePlaceInGallery = 'gallery__item-btn-share_hidden';
const smallActionPanelDownloadBtnsInGallery = `${smallActionPanelContainerInGallery} .small-action-panel`;
const shareBtnsInGallery = `${sharePlaceInGallery} .share-btn`;
const viewBtns = `.gallery__item-view`;
const classActivateSelection = 'gallery__item_active-select';
const classActivateMultiSelectionItem = 'gallery__item_active-multi-select-item';
const classActivateView = 'gallery__item_active-view';
const classActivateIconType = 'gallery__item_active-icon-type';
const classCheckedItem = 'gallery__item_checked';

// galleryViewController
// Responsibilities render and clicks. Without logic!
// Only render model without logic
export function initGalleryViewController({
  isShowDownloadBtn = true,
  isShowShareBtn = true,
  isShowSelectItem = true,
  numberOfRows = 3,
} = {}) {
  let handlerOnClick = () => {};
  let handlerOnLongTouch = () => {};
  let handlerOnClickDownloadBtn = () => {};
  let handlerOnClickShareBtn = () => {};
  let handlerOnClickViewBtn = () => {};
  let handlerOnClickIncrease = () => {};
  let handlerOnClickDecrease = () => {};
  const listenerOnClick = (event) => {
    event.preventDefault();
    handlerOnClick(getDataByEvent(event));
  };
  const listenerOnLongTouch = (event) => {
    event.preventDefault();
    handlerOnLongTouch(getDataByEvent(event));
  };
  const listenerOnClickDownloadBtn = (event) => {
    event.stopPropagation();
    handlerOnClickDownloadBtn(getDataByEvent(event));
  };
  const listenerOnClickShareBtn = (event) => {
    event.stopPropagation();
    handlerOnClickShareBtn(getDataByEvent(event));
  };
  const listenerOnClickView = (event) => {
    event.stopPropagation();
    handlerOnClickViewBtn(getDataByEvent(event));
  };

  console.log('numberOfRows', numberOfRows);

  setRow(numberOfRows);

  return {
    render,
    onClick,
    onLongTouch,

    select,
    unselect,
    unselectAll,
    enableSelect,
    disableSelect,

    showSelectItem: selectItem.show,
    hideSelectItem: selectItem.hide,
    enableMultiSelectItem,
    disableMultiSelectItem,
    onClickIncrease,
    onClickDecrease,
    updateCounter,

    onClickDownloadBtn,
    onClickShareBtn,

    enableView,
    disableView,
    onClickView,

    enableIconType,
  };

  function setRow() {
    $(galleryCssPath).removeClass('gallery_row_1 gallery_row_2 gallery_row_3');
    if (numberOfRows === 1 || numberOfRows === 2 || numberOfRows === 3) {
      $(galleryCssPath).addClass(`gallery_row_${numberOfRows}`);
    }
  }

  function getDataByEvent(event) {
    return {
      id: Number(event.currentTarget.dataset.id),
      type: event.currentTarget.dataset.type,
    };
  }

  function render(items, emptyAlbumText) {
    if (items.length === 0) {
      $(galleryCssPath).hide();
      emptyText.setText(emptyAlbumText);
      emptyText.show();
      $(galleryCssPath).html();
      unsubscribe(items);
    } else {
      const htmlImages = items.map(renderItem).reduce((acc, str) => acc + str, '');
      emptyText.hide();
      $(galleryCssPath).html(htmlImages);
      $(galleryCssPath).show();
      subscribe(items);
    }
  }

  function dataAttributes({ id, type }) {
    return `data-id="${id}" data-type="${type}"`;
  }

  function isShowIcon({ type }) {
    if (isMobile()) return type === '360' || type === 'video';
    return true;
  }

  function getIconSrc({ type }) {
    if (type === '360') return icon360;
    if (type === 'video') return iconVideo;
    return iconImage;
  }

  function renderItem(item) {
    return `
        <div class="gallery__item" ${dataAttributes(item)}>
           <img class="gallery__item-img" src="${item.src}" alt="image" 
                onerror="this.parentElement.style.display='none';"
            />
           ${renderWatermark(item.watermarkSrc)}
           <div class="gallery__item-checkbox ${item.canSelect ? '' : classHiddenCheckboxPlaceInGallery}">
               <img class="gallery__item-checkbox-img-checked" src="${iconCheckboxChecked}" alt="checked" />
               <img class="gallery__item-checkbox-img-unchecked" src="${iconCheckboxUnchecked}" alt="unchecked" />
           </div>
           ${renderIcon(item)}
           <img class="gallery__item-view" ${dataAttributes(item)} src="${getIconSrc(item)}" alt="" />
           <div class="gallery__item-multi-select-item">
               ${selectItem.render({ id: item.id, isShow: isShowSelectItem })}
           </div>
          <div class="gallery__item-small-action-panel ${
            isShowDownloadBtn && item.canDownload ? '' : classHiddenSmallActionPanelContainerInGallery
           }">
              <div class="small-action-panel" ${dataAttributes(item)}>
                   <img class="download-icon small-action-panel__icon" src="${iconDownload}" alt="download icon" />
               </div>
           </div>
           <div class="gallery__item-btn-share ${
             isShowShareBtn && item.canShare ? '' : classHiddenSharePlaceInGallery
           }">
               <div class="share-btn" ${dataAttributes(item)}>
                   <img class="share-icon" src="${iconShare}" alt="share icon" />
                   <div class="share-btn__text">${t('share-btn')}</div>
               </div>
           </div>
       </div>
      `;
  }

  function renderWatermark(src) {
    if (src) {
      return `<div class="gallery__item-watermark" style="background-image:url('${src}')"></div>`;
    }
    return '';
  }

  function renderIcon(item) {
    if (!isShowIcon(item)) return '';
    return `<img class="gallery__item-icon-type" src="${getIconSrc(item)}" alt="icon" />`;
  }

  function subscribe(items) {
    onClickAll(itemCssPath, listenerOnClick);
    onLongTouchAll(itemCssPath, listenerOnLongTouch);
    onClickAll(smallActionPanelDownloadBtnsInGallery, listenerOnClickDownloadBtn);
    onClickAll(shareBtnsInGallery, listenerOnClickShareBtn);
    onClickAll(viewBtns, listenerOnClickView);
    items.forEach((item) => {
      selectItem.onClickPlus(item.id, handlerOnClickIncrease);
      selectItem.onClickMinus(item.id, handlerOnClickDecrease);
    });
  }

  function unsubscribe() {
    unsubscribeOnClickAll(itemCssPath, listenerOnClick);
    unsubscribeOnLongTouchAll(itemCssPath, listenerOnLongTouch);
    unsubscribeOnClickAll(smallActionPanelDownloadBtnsInGallery, listenerOnClickDownloadBtn);
    unsubscribeOnClickAll(shareBtnsInGallery, listenerOnClickShareBtn);
    unsubscribeOnClickAll(viewBtns, listenerOnClickView);
  }

  function onClick(cb) {
    handlerOnClick = cb;
  }

  function onLongTouch(cb) {
    handlerOnLongTouch = cb;
  }

  function onClickIncrease(cb) {
    handlerOnClickIncrease = cb;
  }

  function onClickDecrease(cb) {
    handlerOnClickDecrease = cb;
  }

  function updateCounter(id, count) {
    selectItem.updateAmount(id, count);
  }

  function select(id) {
    const $element = document.querySelector(getItemCssPathWithId(id));
    $element.classList.add(classCheckedItem);
  }

  function unselect(id) {
    const $element = document.querySelector(getItemCssPathWithId(id));
    $element.classList.remove(classCheckedItem);
  }

  function unselectAll() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classCheckedItem);
    });
  }

  function enableSelect() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateSelection);
    });
  }

  function disableSelect() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classActivateSelection);
    });
  }

  function enableMultiSelectItem() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateMultiSelectionItem);
    });
  }

  function disableMultiSelectItem() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classActivateMultiSelectionItem);
    });
  }

  function enableView() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateView);
    });
  }

  function disableView() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classActivateView);
    });
  }

  function enableIconType() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateIconType);
    });
  }

  function onClickDownloadBtn(cb) {
    handlerOnClickDownloadBtn = cb;
  }

  function onClickShareBtn(cb) {
    handlerOnClickShareBtn = cb;
  }

  function onClickView(cb) {
    handlerOnClickViewBtn = cb;
  }
}
